import YouTubePlayer from './YouTubePlayer'

export default YouTubePlayer
